@if (files().length === 0) {
    <app-damage-report-step-header />
    <div class="no-files-container">
        <div
            class="drop-zone p-16 md:p-48 m-24:b"
            ctrlFileDropZone
            [accept]="['image/png', 'image/jpeg', 'application/pdf']"
            maxFileSize="10240"
            (filesSelected)="handleFilesSelected($event)"
            (filesRejected)="handleFilesRejected($event)"
        >
            <p class="c:blue-700">
                {{ introduction() }}
            </p>
            <div
                class="addition inside"
                [innerHTML]="addition()"
            ></div>
            <p class="hide md:block fs:s">
                Ziehe die Dateien in das gestrichelte Feld oder klicke den Button, um Dateien auszuwählen.
            </p>
            <i
                ctrlIcon="folder_camera"
                class="m-16:t md:m-32:t c:blue-700"
            ></i>
            <input
                id="file-select"
                type="file"
                ctrlFileSelect
                [accept]="['image/png', 'image/jpeg', 'application/pdf']"
                maxFileSize="10240"
                multiple
                (filesSelected)="handleFilesSelected($event)"
                (filesRejected)="handleFilesRejected($event)"
            />
            <label
                for="file-select"
                class="-blue m-24:t md:m-48:t fs:m"
                >Foto oder Datei auswählen</label
            >
            <p class="fs:xs m-8:t">JPEG, PNG, PDF</p>
        </div>
        @if (canSkip()) {
            <app-portal-action-buttons
                (clickConfirm)="onNext.emit()"
                (clickReject)="isFirst ? onCancel.emit() : onPrev.emit()"
                [styleConfirmNegative]="true"
                confirmText="Überspringen"
                [rejectText]="isFirst ? 'Abbrechen' : 'Zurück'"
                [isUsedToSubmitForm]="false"
            />
        } @else {
            <app-portal-action-buttons
                (clickConfirm)="onNext.emit()"
                (clickReject)="isFirst ? onCancel.emit() : onPrev.emit()"
                confirmText="Weiter"
                [rejectText]="isFirst ? 'Abbrechen' : 'Zurück'"
                [isConfirmDisabled]="true"
                [isUsedToSubmitForm]="false"
            />
        }
    </div>
} @else {
    <h2 class="c:blue-700 m-16:b md:m-24:b">Ausgewählte Dateien</h2>
    <div
        class="addition"
        [innerHTML]="addition()"
    ></div>
    <div
        class="m-24:b"
        ctrlFileDropZone
        [accept]="['image/png', 'image/jpeg', 'application/pdf']"
        maxFileSize="10240"
        (filesSelected)="handleFilesSelected($event)"
    >
        <div class="files-container">
            @for (file of files(); track $index) {
                <app-selected-file
                    [selectedFile]="file"
                    (onDelete)="deleteFile($event)"
                    (onEdit)="editFile($event)"
                ></app-selected-file>
            }
            <input
                id="file-select-button"
                type="file"
                ctrlFileSelect
                [accept]="['image/png', 'image/jpeg', 'application/pdf']"
                maxFileSize="10240"
                multiple
                (filesSelected)="handleFilesSelected($event)"
                (filesRejected)="handleFilesRejected($event)"
            />
            <label
                for="file-select-button"
                class="-blue file-select-button fs:m"
                ><i ctrlIcon="add"></i>weitere Dateien auswählen</label
            >
        </div>
    </div>

    <app-portal-action-buttons
        (clickConfirm)="onNext.emit()"
        (clickReject)="isFirst ? onCancel.emit() : onPrev.emit()"
        confirmText="Weiter"
        [rejectText]="isFirst ? 'Abbrechen' : 'Zurück'"
        [isUsedToSubmitForm]="false"
    />
}
